import IndividualDevelopmentPlanApprovalView from './component';
import _routes from './routes';

export default IndividualDevelopmentPlanApprovalView;

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanApprovalView/index.js